/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { ConvertDatesToStrings } from '@itk/typescript-utils'
import type { Model_ContactPersonDetailsGet } from '../models/Model_ContactPersonDetailsGet';
import type { Model_ContactPersonExtendedGet } from '../models/Model_ContactPersonExtendedGet';
import type { Model_ContactPersonGet } from '../models/Model_ContactPersonGet';
import type { Model_ContactPersonPermissionReplacePut } from '../models/Model_ContactPersonPermissionReplacePut';
import type { Model_ContactPersonPut } from '../models/Model_ContactPersonPut';
import type { Model_ContactPersonVisibilityGet } from '../models/Model_ContactPersonVisibilityGet';
import type { Model_ContactPersonWithPermissionGet } from '../models/Model_ContactPersonWithPermissionGet';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ContactPersonService {
    /**
     * @param customerId
     * @returns Model_ContactPersonExtendedGet Success
     * @throws ApiError
     */
    public static getApiV1ContactPersonExtended(
        customerId?: ConvertDatesToStrings<string>,
    ): CancelablePromise<Array<Model_ContactPersonExtendedGet>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/contactPerson/extended',
            query: {
                'customerId': customerId,
            },
        });
    }
    /**
     * @param identityId
     * @param customerId
     * @returns Model_ContactPersonDetailsGet Success
     * @throws ApiError
     */
    public static getApiV1ContactPersonDetails(
        identityId?: ConvertDatesToStrings<string>,
        customerId?: ConvertDatesToStrings<string>,
    ): CancelablePromise<Model_ContactPersonDetailsGet> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/contactPerson/details',
            query: {
                'identityId': identityId,
                'customerId': customerId,
            },
        });
    }
    /**
     * @param id
     * @param requestBody
     * @returns Model_ContactPersonGet Success
     * @throws ApiError
     */
    public static putApiV1ContactPerson(
        id: ConvertDatesToStrings<string>,
        requestBody?: ConvertDatesToStrings<Model_ContactPersonPut>,
    ): CancelablePromise<Model_ContactPersonGet> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/contactPerson/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param id
     * @returns any Success
     * @throws ApiError
     */
    public static deleteApiV1ContactPerson(
        id: ConvertDatesToStrings<string>,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/contactPerson/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @param requestBody
     * @returns Model_ContactPersonGet Success
     * @throws ApiError
     */
    public static putApiV1ContactPersonByIdentity(
        requestBody?: ConvertDatesToStrings<Model_ContactPersonPut>,
    ): CancelablePromise<Model_ContactPersonGet> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/contactPerson/byIdentity',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param id
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    public static putApiV1ContactPersonPermissionReplaceAll(
        id: ConvertDatesToStrings<string>,
        requestBody?: ConvertDatesToStrings<Model_ContactPersonPermissionReplacePut>,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/contactPerson/{id}/permission/replaceAll',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param id
     * @returns Model_ContactPersonWithPermissionGet Success
     * @throws ApiError
     */
    public static getApiV1ContactPersonPermissions(
        id: ConvertDatesToStrings<string>,
    ): CancelablePromise<Model_ContactPersonWithPermissionGet> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/contactPerson/{id}/permissions',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @param customerId
     * @param identityId
     * @returns Model_ContactPersonVisibilityGet Success
     * @throws ApiError
     */
    public static getApiV1ContactPersonVisibility(
        customerId?: ConvertDatesToStrings<string>,
        identityId?: ConvertDatesToStrings<string>,
    ): CancelablePromise<Array<Model_ContactPersonVisibilityGet>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/contactPerson/visibility',
            query: {
                'customerId': customerId,
                'identityId': identityId,
            },
        });
    }
}
